//export const API_BASE = "http://localhost:8080"
export const API_BASE = window.location.origin;